import { slideUp, slideDown } from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', (event) => {
    const accordionSections = document.querySelectorAll('.faqs-section');
    accordionSections.forEach(section => {
        const tabRepet = section.querySelectorAll('.faqs-item');

        tabRepet.forEach(tabRepetEle => {
            const title = tabRepetEle.querySelector('.faqs-title');
            const content = tabRepetEle.querySelector('.faqs-description');

            if (content) {
                title.addEventListener('click', function() {
                    const parent = tabRepetEle.parentElement; // .el-accordion-wrap
                    const isOpen = tabRepetEle.classList.contains('is-active');

                    // Close siblings
                    Array.from(parent.children).forEach(sibling => {
                        if (sibling !== tabRepetEle && sibling.classList.contains('is-active')) {
                            sibling.classList.remove('is-active');
                            const siblingContent = sibling.querySelector('.faqs-description');
                            slideUp(siblingContent);
                        }
                    });

                    // Toggle current
                    if (isOpen) {
                        tabRepetEle.classList.remove('is-active');
                        slideUp(content);
                    } else {
                        tabRepetEle.classList.add('is-active');
                        slideDown(content);
                    }
                });
            }
        });
    });
});